// extracted by mini-css-extract-plugin
export default {"root":"RadioButton_root__ZCerM","input":"RadioButton_input__V4oyz","ellipse":"RadioButton_ellipse__AMteO","text":"RadioButton_text__FCMh0"};